import React, { useEffect, useRef } from "react";
import Layout from "../Layout/Layout";
import HabitsTracker from "../Components/HabitDashboard";
import useUserStore from "../zustand-stores/UserStore";
import DashboardTaskManagement from "../Components/Dashboard/DashboardTaskManagement";
import LevelProgressBar from "../Components/Dashboard/LevelProgressBar";
import PowerScoresCard from "../Components/Dashboard/PowerScoresCard";
import PowerStreaksCard from "../Components/Dashboard/PowerStreaksCard";
import TotalScoresCard from "../Components/Dashboard/TotalScoresCard";
import DailyJournalSection from "../Components/Dashboard/DailyJournalSection";
import RecentCoursesSection from "../Components/Dashboard/RecentCoursesSection";
import MemorySection from "../Components/Dashboard/MemorySection";
import UserProfileApi from "../routes/userProfile";

export default function Dashboard() {
  const { user } = useUserStore();
  const streaksSectionRef = useRef(null);

  useEffect(() => {
    const updateTimeZone = async () => {
      try {
        const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

        await UserProfileApi.updateTimeZOne({
          time_zone: userTimeZone,
        });
      } catch (error) {
        console.error("Failed to update timezone:", error);
      }
    };

    updateTimeZone();
  }, []);

  const date = new Date();

  const getFormattedDate = (dateString) => {
    const d = new Date(dateString);
    const day = d.getDate();
    const month = d.toLocaleString("default", { month: "short" });
    const year = d.getFullYear();

    const getOrdinal = (n) => {
      const s = ["th", "st", "nd", "rd"],
        v = n % 100;
      return n + (s[(v - 20) % 10] || s[v] || s[0]);
    };

    return `${getOrdinal(day)} ${month}, ${year}`;
  };

  const scrollToStreaks = () => {
    streaksSectionRef.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
    <Layout>
      <div className="page-content">
        <div className="dash-content dashboard-all-content">
          <div className="d-flex flex-column gap-4">
            <div className="dash-title-date align-items-center flex-wrap gap-2">
              <h1 className="welcome-title mb-0">Hi, {user.full_name}</h1>
              <div className="d-flex align-items-center gap-2 ms-md-auto">
                <button
                  type="button"
                  className="dashboard-streaks-jump-btn d-md-none"
                  onClick={scrollToStreaks}
                >
                  Streaks
                </button>
                <div className="date-display">{getFormattedDate(date)}</div>
              </div>
            </div>

            <div className="row g-4">
              <div className="col-12 col-md-6 ">
                <div className="d-flex flex-column gap-3 journal-container">
                  <LevelProgressBar />
                  <DailyJournalSection />
                </div>
              </div>
              <div className="col-12 col-md-6 d-flex align-items-start">
                <RecentCoursesSection />
              </div>
            </div>

            <div className="row g-4 row-for-habits-cards dashboard-habits-tasks-row">
              <HabitsTracker rootClassName="d-none d-md-block" />
              <DashboardTaskManagement />
            </div>

            <section
              ref={streaksSectionRef}
              id="dashboard-streaks-section"
              className="dashboard-streaks-section"
              aria-labelledby="dashboard-streaks-heading"
            >
              <h4
                id="dashboard-streaks-heading"
                className="text-white weekly-title streaks-section-title mb-3"
              >
                Streaks
              </h4>
              <div className="row g-4 row-for-dashboard-doughnut">
                <PowerScoresCard />
                <PowerStreaksCard />
              </div>
            </section>

            <div className="row g-4 dashboard-total-scores-row">
              <TotalScoresCard />
            </div>

            <div className="dashboard-memory-section">
              <MemorySection />
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}
